import React from "react"

const CallIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0359 8.05236C15.6546 10.2876 14.9587 12.6195 13.4341 14.0569C13.145 14.3294 13.0519 14.77 13.279 15.096C13.7624 15.79 14.3122 16.4497 14.9287 17.0666C15.5443 17.6827 16.2024 18.2322 16.8947 18.7155C17.2216 18.9437 17.6635 18.849 17.9356 18.5576C19.3706 17.0207 21.7093 16.3173 23.9507 16.9385C26.9718 17.776 28.6722 20.7029 27.7486 23.4761C25.0421 31.6027 14.6224 23.5478 11.5374 20.4605C8.37784 17.2986 0.446808 6.93869 8.50328 4.25163C11.2744 3.32732 14.1992 5.02898 15.0359 8.05236Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default CallIcon
